import React from "react";
import cx from "classnames";
import { Text } from "@foris/avocado-suite";
import styles from "./textarea.module.scss";

interface TextareaProps {
  label?: string;
  value?: string;
  maxLength?: number;
  className?: string;
  onChange?: (value: string) => void;
}

const limit = 250;
const Textarea = ({
  label,
  value = "",
  maxLength = limit,
  className = "",
  onChange,
}: TextareaProps) => {
  return (
    <div className={cx(styles.textarea, className)}>
      <Text className={styles.textareaLabel} type="sm">
        {label}
        <span className={styles.textareaLabel_counter}>
          <span className={styles.textareaCounter}>
            {value?.length || 0} / {maxLength}
          </span>
        </span>
      </Text>

      <textarea
        className={styles.textareaField}
        maxLength={limit}
        value={value}
        onChange={e => onChange?.(e?.target?.value || "")}
      />
    </div>
  );
};

export default Textarea;
